<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    :title="row.id ? '编辑' : '新建'"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="140px">
      <el-form-item label="设备类型型号：" prop="device">
        <Cascader
          style="width: 240px;"
          placeholder="设备类型型号"
          :multiple="false"
          v-model="form.device"
          :query="$api.basicdata.device_model_cascade + '?devType=01'"
        >
        </Cascader>
      </el-form-item>
      <el-form-item label="设备SN码：" prop="assetNumber">
        <el-input v-model.trim="form.assetNumber" clearable placeholder="请填写设备SN码"></el-input>
      </el-form-item>
      <el-form-item label="设备IMEI号：">
        <el-input v-model.trim="form.imei" clearable placeholder="请填写设备IMEI号"></el-input>
      </el-form-item>
      <el-form-item label="大客户：" prop="customerId">
        <Select
          style="width: 240px;"
          placeholder="大客户"
          v-model="form.customerId"
          :query="$api.basicdata.customer_select + '?accountLevel=kalifon'"
        >
        </Select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="notBtn">取 消</el-button>
      <el-button type="primary" @click="okBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Select from '@manage/components/CommonForm/Select'
import Cascader from '@manage/components/CommonForm/Cascader'
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    row: {
      type: Object
    }
  },
  components: {
    Select,
    Cascader
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        id: '',
        devType: '01', // 01厨冷 02红酒
        device: [],
        assetNumber: '',
        imei: '',
        customerId: ''
      },
      rules: {
        device: [
          {
            required: true,
            message: '请选择设备类型型号',
            trigger: 'change'
          }
        ],
        assetNumber: [
          {
            required: true,
            message: '请填写设备SN码',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[\u4e00-\u9fa5\x21-\x7E]+$/
              if (!reg.test(value)) {
                callback(new Error('设备SN码由中英文字符、数字和特殊符号组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        customerId: [
          {
            required: true,
            message: '请选择大客户',
            trigger: 'change'
          }
        ]
      },
      addApi: this.$api.freezer.device_add,
      updateApi: this.$api.freezer.device_update
    }
  },
  mounted() {
    if (this.row.id) {
      this.queryDetail(this.row.id)
    }
  },
  methods: {
    queryDetail(id) {
      let params = {
        id: id
      }
      this.$ajax.get(this.$api.freezer.device_detail, params).then((res) => {
        this.form = res.data
        this.form.device = []
        this.form.device.push(res.data.modelName)
        this.form.device.push(res.data.assetId)
      })
    },
    notBtn() {
      this.$emit('update:visible', false)
    },
    okBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            id: this.form.id,
            devType: this.form.devType, // 01厨冷 02红酒
            modelName: this.form.device[0],
            assetId: this.form.device[1],
            assetNumber: this.form.assetNumber,
            imei: this.form.imei,
            customerId: this.form.customerId
          }

          let api = this.row.id ? this.updateApi : this.addApi
          this.$ajax.post(api, params).then(() => {
            this.$message.success(`${this.row.id ? '修改成功' : '新建成功'}`)
            this.notBtn()
            this.$emit('refresh')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit-dialog {
  .el-form-item__content {
    div {
      width: 240px;
    }
  }
}
</style>
